module.exports = __webpack_public_path__ + "img/menu_up.a6eb55f5.svg";